export const localPaths = {
    home: '',
    plan: 'plan',
    pro: 'plan',
    payment: 'payment',
    paymenttestpp: 'paymenttestpp',
    profile: 'profile',
    accountSetting: 'account-setting',
    subscription: 'subscription',
    cancelSubscription: 'cancel-subscription',
    promotion: 'promotion',
    redeem: 'redeem',   // a coupon code (#116), website only
    voucher: 'voucher',     // an affiliate's voucher link, /members/voucher/CODE (docs/vouchers-plan.md)
    affiliate: 'affiliate', // an affiliate's own summary
};
